import React from 'react';

interface Alert {
    id: string;
    type: 'alert' | 'news';
    content: string;
    timestamp: Date;
}

interface AlertFeedProps {
    title?: string;
    alerts: Alert[];
    className?: string;
}

const formatTime = (date: Date): string => {
    const now = new Date();
    const diffMs = now.getTime() - new Date(date).getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} mins ago`;

    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} hours ago`;

    return new Date(date).toLocaleDateString();
};

export const AlertFeed: React.FC<AlertFeedProps> = ({
    title = 'Alpha Feed',
    alerts,
    className = '',
}) => {
    return (
        <div className={`trader-feed ${className}`}>
            <div className="trader-feed-header">
                <span className="trader-feed-header-icon">📡</span>
                <span>{title}</span>
            </div>

            <div className="trader-feed-list">
                {alerts.map((alert) => (
                    <div key={alert.id} className="trader-feed-item">
                        <span className={`trader-feed-badge ${alert.type}`}>
                            {alert.type === 'alert' ? 'Trade Alert' : 'Market News'}
                        </span>
                        <p className="trader-feed-content">{alert.content}</p>
                        <span className="trader-feed-time">{formatTime(alert.timestamp)}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AlertFeed;
